/// <reference types="./content_library.d.mts" />
import * as $data_point from "../../common/data/data_point.mjs";
import * as $data_source from "../../common/data/data_source.mjs";
import * as $colors from "../../ds/ds/colors.mjs";
import * as $label from "../../ds/ds/components/label.mjs";
import * as $skeleton from "../../ds/ds/components/skeleton.mjs";
import * as $table from "../../ds/ds/components/table.mjs";
import * as $tooltip from "../../ds/ds/components/tooltip.mjs";
import * as $int from "../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import * as $string from "../../gleam_stdlib/gleam/string.mjs";
import * as $el from "../../lustre/lustre/element.mjs";
import * as $css from "../../sketch/sketch/css.mjs";
import * as $length from "../../sketch/sketch/css/length.mjs";
import { px } from "../../sketch/sketch/css/length.mjs";
import * as $h from "../../sketch_lustre/sketch/lustre/element/html.mjs";
import { toList, prepend as listPrepend } from "../gleam.mjs";

export function choose_settings(state, active) {
  let light = $colors.light;
  if (state === "green") {
    return [light.success_800, light.success_50, light.success_800, active];
  } else if (state === "blue") {
    return [light.blue_800, light.blue_50, light.blue_800, active];
  } else if (state === "red") {
    return [light.error_800, light.error_50, light.error_800, active];
  } else if (state === "grey") {
    return [light.grey_800, light.grey_50, light.grey_800, active];
  } else if (state === "purple") {
    return [light.ai_800, light.ai_50, light.ai_800, active];
  } else if (state === "yellow") {
    return [light.warning_800, light.warning_50, light.warning_800, active];
  } else {
    return [light.grey_800, light.grey_50, light.grey_50, active];
  }
}

export function view_loading_table(num_columns) {
  return $table.body(
    (() => {
      let _pipe = $table.row(
        listPrepend(
          $table.cell($el.none()),
          (() => {
            let _pipe = $table.cell($skeleton.skeleton(100, 25));
            return $list.repeat(_pipe, num_columns);
          })(),
        ),
      );
      return $list.repeat(_pipe, 5);
    })(),
  );
}

export function make_counter_text(page, page_size) {
  let lower_bound = $int.to_string(page * page_size);
  let higher_bound = $int.to_string((page + 1) * page_size);
  return (lower_bound + " — ") + higher_bound;
}

export function tooltip_content(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.background($colors.light.grey_50),
      $css.color($colors.light.grey_800),
      $css.border("1px solid"),
      $css.border_radius(px(8)),
      $css.max_width(px(300)),
      $css.padding(px(16)),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function view_source_verification_label(source) {
  let _block;
  let $1 = source.status;
  if ($1 instanceof $data_source.Pending) {
    _block = [
      $label.current(),
      "Pending",
      "This data source is pending validation.",
    ];
  } else if ($1 instanceof $data_source.Verified) {
    _block = [
      $label.success(),
      "Verified",
      "This data source is verified and will be used by the AI.",
    ];
  } else if ($1 instanceof $data_source.NotVerified) {
    _block = [
      $label.neutral(),
      "Not verified",
      "This data source hasn't been assigned to someone for verification yet.",
    ];
  } else if ($1 instanceof $data_source.Archived) {
    _block = [$label.error(), "Archived", "This data source is archived."];
  } else if ($1 instanceof $data_source.Outdated) {
    _block = [
      $label.error(),
      "Outdated",
      "This data source is outadated, assign someone to it for verification.",
    ];
  } else if ($1 instanceof $data_source.Processing) {
    _block = [
      $label.neutral(),
      "Processing",
      "Steerlab's AI is ingesting and analysing data.",
    ];
  } else {
    _block = [
      $label.error(),
      "Failed",
      "Ingestion has failed. Re-upload the file again to contact Steerlab.",
    ];
  }
  let $ = _block;
  let status = $[0];
  let content = $[1];
  let tooltip_explanation = $[2];
  let label_element = $label.label(toList([status, $label.content(content)]));
  return $tooltip.tooltip(
    toList([]),
    label_element,
    tooltip_content(toList([]), toList([$h.text(tooltip_explanation)])),
  );
}

export function construct_data_point_string(data_point) {
  let display = data_point.display;
  if (display instanceof $data_point.DisplayText) {
    let as_html = display.as_html;
    return $option.unwrap(as_html, "");
  } else {
    let _pipe = toList([
      "Sheet name: " + display.sheet_name,
      "Header: " + $option.unwrap(display.header, ""),
      "Section: " + $option.unwrap(display.section, ""),
      "Sub Section: " + $option.unwrap(display.sub_section, ""),
      "Context Question: " + $option.unwrap(display.context_question, ""),
      "Comments: " + $option.unwrap(display.comments, ""),
      "Question: " + display.question,
      "Answer: " + display.answer,
    ]);
    return $string.join(_pipe, "\n ");
  }
}

export const ds_statuses = /* @__PURE__ */ toList([
  /* @__PURE__ */ new $data_source.Verified(),
  /* @__PURE__ */ new $data_source.Pending(),
  /* @__PURE__ */ new $data_source.NotVerified(),
  /* @__PURE__ */ new $data_source.Outdated(),
]);
